import { section } from "@/neon";

section("page", {
  onLoad() {},
  onUnload() {},
});
